import { apiClient, API_BASE_URL } from './apiClient';

const BASE = `${API_BASE_URL}/api/finance/fundraising`;

export const financeFundraisingAPI = {
  getRounds: () => apiClient(`${BASE}/rounds/`),
  createRound: (data) => apiClient(`${BASE}/rounds/`, { method: 'POST', body: JSON.stringify(data) }),
  updateRound: (id, data) =>
    apiClient(`${BASE}/rounds/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  deleteRound: (id) => apiClient(`${BASE}/rounds/${id}`, { method: 'DELETE' }),
  bulkDeleteRounds: (ids) =>
    apiClient(`${BASE}/rounds/bulk-delete`, { method: 'POST', body: JSON.stringify({ ids }) }),

  getInvestments: () => apiClient(`${BASE}/investments/`),
  createInvestment: (data) =>
    apiClient(`${BASE}/investments/`, { method: 'POST', body: JSON.stringify(data) }),
  updateInvestment: (id, data) =>
    apiClient(`${BASE}/investments/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  deleteInvestment: (id) => apiClient(`${BASE}/investments/${id}`, { method: 'DELETE' }),
  bulkDeleteInvestments: (ids) =>
    apiClient(`${BASE}/investments/bulk-delete`, { method: 'POST', body: JSON.stringify({ ids }) }),

  getCapTable: () => apiClient(`${BASE}/cap-table/`),
  getCapTableSummary: () => apiClient(`${BASE}/cap-table/summary`),
  createCapEntry: (data) =>
    apiClient(`${BASE}/cap-table/`, { method: 'POST', body: JSON.stringify(data) }),
  updateCapEntry: (id, data) =>
    apiClient(`${BASE}/cap-table/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  deleteCapEntry: (id) => apiClient(`${BASE}/cap-table/${id}`, { method: 'DELETE' }),
  bulkDeleteCapEntries: (ids) =>
    apiClient(`${BASE}/cap-table/bulk-delete`, { method: 'POST', body: JSON.stringify({ ids }) }),
};

export default financeFundraisingAPI;
